<app-header [breadCrumbs]="breadCrumbs" *ngIf="pagePathURL !='/advertisement'"></app-header>
<router-outlet></router-outlet>
<div class="loader" [ngClass]="{ 'loader-active': loaderStatus }" *ngIf="loaderStatus">
  <div class="loader-content">
    <mat-spinner [diameter]="25"></mat-spinner>
    <div class="loader-content-text">Please wait...</div>
  </div>
</div>
<app-footer *ngIf="pagePathURL !='/advertisement'"></app-footer>
